<rappider-list-grid [config]="config"
                    [data]="uiDataEvents"
                    [loading]="loadingState"
                    (columnActionClick)="onItemActionClick($event)"
                    (listActionClick)="navigateCreateDataEventPage()"></rappider-list-grid>
